module.exports = __webpack_public_path__ + "static/media/work_hours.b7cf7d56.png";